(function (window) {
    "use strict";
    function defineTabsHelper() {
        var tabsHelper = {};
        tabsHelper.openTab = function (evt, tabName) {
            var i, x, tablinks;
            x = document.getElementsByClassName("city");
            for (i = 0; i < x.length; i++) {
                x[i].style.display = "none";
            }
            tablinks = document.getElementsByClassName("tablink");
            for (i = 0; i < x.length; i++) {
                tablinks[i].className = tablinks[i].className.replace(" tab-active", "");
            }
            document.getElementById(tabName).style.display = "block";
            evt.currentTarget.firstElementChild.className += " tab-active";
        };
        return tabsHelper;
    }
    //define globally if it doesn't already exist
    if (typeof (tabsHelper) === "undefined") {
        window.tabsHelper = defineTabsHelper();
    } else {
        console.log("tabsHelper already defined.");
    }
})(window);